module.exports = __webpack_public_path__ + "img/download-icon.b685f4a9.png";